export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Administracja": "Administration",
        "Aktualizacja: {0}": "Update: {0}",
        "Alias": "Alias",
        "Alias został przepięty.": "Alias has been switched.",
        "Anuluj": "Cancel",
        "Docs": "Docs",
        "Dodaj": "Add",
        "Dodaj słowo": "Add word",
        "Dodaj synonimy": "Add synonyms",
        "dodane i edytowane przeze mnie": "added and edited by me",
        "Edytuj": "Edit",
        "Health": "Health",
        "Indeks": "Index",
        "Indeks został usunięty.": "Index has been deleted.",
        "Lista indeksów": "List of indices",
        "Mappingi": "Mappings",
        "Nazwa aliasu": "Alias name",
        "Po jednym synonimie w wierszu": "One synonym per line",
        "Pokaż tylko moje dokumenty": "Show only my documents",
        "Posiada załączniki": "Has attachments",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Przebudowanie indeksów": "Rebuilding indices",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "Rebuilding indicesnnOperation may take from a few seconds to several hours depending on the size of indices.nnShould only be used when applying changes made in synonym or excluded word dictionaries.",
        "Przeindeksowanie danych": "Data reindexing",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "Data reindexingnnOperation may take from a few seconds to several hours depending on the amount of data in the database.nnShould only be used when noticing missing data in indices.",
        "Przepnij alias": "Switch alias",
        "Rozmiar": "Size",
        "Słowa wykluczone": "Excluded words",
        "Słowo": "Word",
        "Słowo bazowe": "Base word",
        "Słowo wykluczone": "Excluded word",
        "Słowo zostało dodane.": "Word has been added.",
        "Słowo zostało usunięte.": "Word has been deleted.",
        "Słowo zostało zaktualizowane.": "Word has been updated.",
        "Status": "Status",
        "Synonimy": "Synonyms",
        "Synonimy zostały dodane.": "Synonyms have been added.",
        "Synonimy zostały usunięte.": "Synonyms have been deleted.",
        "Synonimy zostały zaktualizowane.": "Synonyms have been updated.",
        "System": "System",
        "Szczegóły": "Details",
        "Szukaj we wszystkich wersjach": "Search in all versions",
        "Szukane słowo": "Searched word",
        "tylko dokumenty wersjonowane": "only versioned documents",
        "Ustawienia": "Settings",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "Index removalnnOperation is irreversible. Are you sure you want to delete the selected index?",
        "Usuń": "Delete",
        "Usuń indeks": "Delete index",
        "Wyszukiwanie": "Searching",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "Index rebuild task has started.",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "Data reindexing task has started.",
        "Zamknij": "Close",
        "Zapisz": "Save",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "Changes will take effect only after index rebuild."
    }
};
